import React, { FC } from 'react';
import _ from '@dh-fe/translate';
import useMediaQuery from 'hooks/useMediaQuery';
import { Breakpoints } from 'configs/breakpoints';
import Image from 'components/Image/Image';
import { useTheme } from 'contexts/ThemeContext';
import classnames from 'classnames';
import Icon, { IconList } from 'components/Icon';
import style from './ItsTimeSection.module.scss';
import { getContent } from './ItsTimeSectionContent';

const Dots: FC<DotsProps> = ({ left = false }) => (
    <div className={`${style.dots} ${left ? style.dotLeft : style.dotRight}`}>
        <div className={style.dot} />
        <div className={style.dot} />
        <div className={style.dot} />
        <div className={style.dot} />
        <div className={style.dot} />
    </div>
);

const Circle: FC<CircleProps> = ({ children, number, color }) => (
    <div className={style.circle}>
        <div className={style.number} style={{ background: color }}>
            {number}
        </div>
        {children}
    </div>
);

const ItsTimeSection = () => {
    const isMobile = useMediaQuery(Breakpoints.VERY_SMALL);
    const { bg, bgMobileCompress, bgCompress, bgMobile, button } = getContent();
    const { theme } = useTheme();
    return (
        <section className={classnames(style[theme], style.startSection)}>
            {isMobile ? (
                <Image webp={bgMobileCompress} unCompressed={bgMobile} alt="background image" />
            ) : (
                <Image webp={bgCompress} unCompressed={bg} alt="background image" />
            )}
            <div className={style.gradient} />
            <div className={style.container}>
                <h1>{_`It's your time to shine!`}</h1>
                <h2>
                    {_`Just create your profile, upload your amazing content,[br]keep doing what you love, and get paid![/br]`
                        .parseBB()
                        .toJSX()}
                </h2>
                <div className={style.content}>
                    <div className={style.item}>
                        <Circle number={1} color="var(--time-color-1)">
                            <Icon icon={IconList.profileAddSolid} size="5.6rem" />
                        </Circle>
                        <div>{_`Create an account`}</div>
                    </div>
                    <Dots left />
                    <div className={style.item}>
                        <Circle number={2} color="var(--time-color-2)">
                            <Icon icon={IconList.uploadSolid} size="5.6rem" />
                        </Circle>
                        <div>{_`Upload your content`}</div>
                    </div>
                    <Dots />
                    <div className={style.item}>
                        <Circle number={3} color="var(--time-color-3)">
                            <Icon icon={IconList.dollarSolid} size="5.6rem" />
                        </Circle>
                        <div>{_`Get Paid`}</div>
                    </div>
                </div>
                <div className={style.buttonContainer}>{button}</div>
            </div>
        </section>
    );
};

export default ItsTimeSection;

interface DotsProps {
    left?: boolean;
}
interface CircleProps {
    children: JSX.Element;
    number: number;
    color: string;
}
